// checks whether a field should be visible based on its condition and current preview values.
export const isVisible = (item, values = {}) => {
  const grouped = item?.condition;
  if (!grouped?.groups?.length) return true;

  const evaluateCondition = ({ dependsOnFieldId, expectedValue, operator = '==' }) => {
    const actual = values?.[dependsOnFieldId] || '';

    switch (operator) {
      case '==': return actual == expectedValue;
      case '!=': return actual != expectedValue;
      case '>': return parseFloat(actual) > parseFloat(expectedValue);
      case '<': return parseFloat(actual) < parseFloat(expectedValue);
      case '>=': return parseFloat(actual) >= parseFloat(expectedValue);
      case '<=': return parseFloat(actual) <= parseFloat(expectedValue);
      case 'contains': return actual.includes(expectedValue);
      case 'not_contains': return !actual.includes(expectedValue);
      case 'not_empty': return !!actual;
      default: return actual == expectedValue;
    }
  };

  const evaluateGroup = (group) => {
    const results = group.conditions.map(evaluateCondition);
    return group.logic === 'AND'
      ? results.every(Boolean)
      : results.some(Boolean);
  };

  const groupResults = grouped.groups.map(evaluateGroup);
  return grouped.logic === 'AND'
    ? groupResults.every(Boolean)
    : groupResults.some(Boolean);
};



// Converts option string (comma-separated) into trimmed array.
export const parseFieldOptions = (optionStr) =>
  optionStr?.trim()
    ? optionStr.split(',').map((s) => s.trim())
    : [];
